import { render } from "./PromptWriter.vue?vue&type=template&id=4bb3019d&scoped=true"
import script from "./PromptWriter.vue?vue&type=script&lang=js"
export * from "./PromptWriter.vue?vue&type=script&lang=js"

import "./PromptWriter.vue?vue&type=style&index=0&id=4bb3019d&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb3019d"]])

export default __exports__